import { render, staticRenderFns } from "./AddClassTypeModal.vue?vue&type=template&id=d35eee5a&scoped=true&"
import script from "./AddClassTypeModal.vue?vue&type=script&lang=js&"
export * from "./AddClassTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35eee5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d35eee5a')) {
      api.createRecord('d35eee5a', component.options)
    } else {
      api.reload('d35eee5a', component.options)
    }
    module.hot.accept("./AddClassTypeModal.vue?vue&type=template&id=d35eee5a&scoped=true&", function () {
      api.rerender('d35eee5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/classes/AddClassTypeModal.vue"
export default component.exports